// フィルタリングUI（sections/subu-filter-buttons.liquid）から遷移した際のURLクエリ（filter.*等）を、
// Dawn標準のSORTフォームへ隠しinputとして注入する。
// enable_filtering: false のためSORTフォーム内にフィルター項目が存在せず、
// ソート変更時にDawn標準のFacetFiltersForm（assets/facets.js）がフォーム内容だけでURLを
// 再構築してしまい、フィルター条件が失われるための対応。
(function () {
  var EXCLUDED_KEYS = ['sort_by', 'q', 'options[prefix]', 'page'];

  function injectPreservedFilters() {
    var forms = document.querySelectorAll('facet-filters-form form');
    if (!forms.length) return;

    var params = new URLSearchParams(window.location.search);

    forms.forEach(function (form) {
      params.forEach(function (value, key) {
        if (EXCLUDED_KEYS.indexOf(key) !== -1) return;
        if (form.elements[key]) return;

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });
    });
  }

  // SORTドロップダウンの並び順（2026-08-26 ユーザー指定）
  var SORT_VALUE_ORDER = [
    'manual',
    'created-descending',
    'created-ascending',
    'best-selling',
    'price-descending',
    'price-ascending',
    'title-ascending',
    'title-descending',
    'most-relevant',
  ];

  function reorderSortOptions() {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      var options = Array.prototype.slice.call(select.options);
      options
        .sort(function (a, b) {
          var indexA = SORT_VALUE_ORDER.indexOf(a.value);
          var indexB = SORT_VALUE_ORDER.indexOf(b.value);
          if (indexA === -1) indexA = SORT_VALUE_ORDER.length;
          if (indexB === -1) indexB = SORT_VALUE_ORDER.length;
          return indexA - indexB;
        })
        .forEach(function (option) {
          select.appendChild(option);
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectPreservedFilters();
    reorderSortOptions();
  });
})();
